import { ShareSettingPageKey } from '@/types';
import {
  fetchFloatingWindowDocument,
  fetchGetFloatingWindowCouponRecordDocument,
  fetchShareSettingsDocument,
} from '../graphql/docs';
import { fetcher } from '../graphql/fetcher';

/**
 * 获取浮窗数据
 */
export const fetchFloatingWindow = async () => {
  const res = await fetcher.query(fetchFloatingWindowDocument, {});
  return res.data.value?.floatingWindow;
};

/**
 * 获取浮窗优惠券记录
 */
export const fetchGetFloatingWindowCouponRecord = async () => {
  const res = await fetcher.query(fetchGetFloatingWindowCouponRecordDocument, {});
  return res.data.value?.getFloatingWindowCouponRecord;
};

/**
 * 获取全局分享设置
 */
export const fetchShareSettings = async (pageKeys: ShareSettingPageKey[]) => {
  const res = await fetcher.query(fetchShareSettingsDocument, {
    variables: {
      pageKeys,
    },
  });
  return res.data.value?.shareSettings;
};
